export default __webpack_public_path__ + "static/media/Q6.78bf409c.png";